import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import moment from "moment";
import { useHistory } from "react-router";

import { Button, Dialog, DialogContent } from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";
import OpenDocument from "../../helpers/openDocument";
import { getFileMime } from "../../helpers/Common_functions";

function ViewProjectReports({ location, SetSelectedMenu, loggedUser }) {
    const [list, setList] = React.useState([]);
    const [selected, setSelected] = React.useState(location.state?.status ?? "all");
    const [fileView, setFileView] = React.useState(null);

    const history = useHistory();
    useEffect(() => {
        setSelected(location.state?.status ?? "all");
    }, [location.state]);

    useEffect(() => {
        SetSelectedMenu({
            menu: "report/project",
            title: "Project Reports Management"
        })
    }, []);

    const columns = [

        {
            name: "startDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "endDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        // {
        //     name: "uploader.names",
        //     label: "Submitted By",
        //     options: {
        //         filter: true,
        //         sort: true,
        //     },
        // },
        // {
        //     name: "attachment",
        //     label: "Report Document",
        //     options: {
        //         customBodyRender: (value, tableMeta) => {
        //             const reportName = tableMeta.rowData[1];
        //             return value ? (
        //                 <Button
        //                     startIcon={<PictureAsPdf />}
        //                     onClick={(event) => {
        //                         event.stopPropagation();
        //                         setFileView(value);
        //                     }}
        //                 >
        //                     {`${reportName} Document`}
        //                 </Button>
        //             ) : (
        //                 <span>No Document</span>
        //             );
        //         },
        //     },
        // }
    ];

    return <div className="w-full mb-12 px-4">

        <DatatableComponent
            order={location.state?.order}
            onRowClick={(data, rowMeta, event) => {
                if (rowMeta && rowMeta.rowIndex !== undefined) {
                    const rowData = list[rowMeta.rowIndex];
                    const { startDate, endDate, id: reportId } = rowData;

                    if (startDate && endDate && reportId) {
                        history.push({
                            pathname: '/admin/reports/view-project-reports',
                            state: { startDate, endDate, reportId },
                        });
                    } else {
                        history.push('/admin/reports/view-project-reports');
                    }
                } else {
                    history.push('/admin/reports/view-project-reports');
                }
            }}
            processData={(data) => {
                setList(data.data);
                return data;
            }}
            elevation={1}
            columns={columns}
            search={false}
            searchfield={true}
            viewColumns={false}
            // url={`/api/report/projects/view_all`}
            url={`/api/report/project/view-reports`}
            title={`Project Reports`}
        />


        <Dialog maxWidth={'md'} fullWidth={true} open={fileView !== null} onClose={() => setFileView(null)}>
            <DialogContent>
                {fileView !== null && <OpenDocument
                    downloadable={true}
                    document={fileView}
                    name={'supportDocument'}
                    specialName={fileView}
                    type={"permission-doc"}
                    mimeType={getFileMime(fileView)} />}
            </DialogContent>
        </Dialog>
    </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewProjectReports);
